import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  imports: [],
  template: `
    <nav aria-label="Paginación">
      <ul class="pagination">
        <li class="page-item" [class]="{ disabled: page === 1 }">
          <button class="page-link" (click)="updatePage(-1)">
            <i class="bi bi-chevron-left"></i>
          </button>
        </li>

        @for (pageNumber of pageNumbers(); track $index) {
          <li class="page-item" [class]="{ active: page === pageNumber }">
            <button
              class="page-link"
              (click)="changePage(pageNumber)"
              [disabled]="page === pageNumber"
            >
              {{ pageNumber }}
            </button>
          </li>
        }

        <li
          class="page-item"
          [class]="{ disabled: page === pageNumbers().length }"
        >
          <button class="page-link" (click)="updatePage(1)">
            <i class="bi bi-chevron-right"></i>
          </button>
        </li>
      </ul>
    </nav>
  `,
  styles: `
    .pagination {
      gap: 8px;
      justify-content: end;

      .page-item {
        .page-link {
          width: 40px;
          height: 40px;
          text-align: center;
          padding: 0;
          line-height: 35px;
          font-weight: bold;
          color: #00332d;
          border: 2px solid #00332d;
          border-radius: 0;

          &:hover {
            background-color: rgba(0, 51, 45, 0.05);
          }
        }

        &.active .page-link {
          background-color: #00332d;
          color: white;
          border-color: #00332d;
        }

        &.disabled .page-link {
          color: #ccc;
          border-color: #ccc;
          background-color: transparent;
        }
      }
    }
  `
})
export class PaginationComponent {
  @Input({ required: true }) page!: number;
  @Input({ required: true }) total!: number;
  @Input() limit = 10;
  @Output() pageChange = new EventEmitter<number>();

  max = 5;

  pageNumbers() {
    const total = Math.ceil(this.total / this.limit);

    if (total === 0) {
      return Array.from({ length: 1 }, (_, i) => i + 1);
    } else if (total <= this.max) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const half = Math.floor(this.max / 2);
    let to = this.max;

    if (this.page + half > total) {
      to = total;
    } else if (this.page > half) {
      to = this.page + half;
    }

    const from = to - this.max;

    return Array.from({ length: this.max }, (_, i) => from + i + 1);
  }

  updatePage(amount: number) {
    this.page += amount;
    this.pageChange.emit(this.page);
  }

  changePage(page: number) {
    this.page = page;
    this.pageChange.emit(this.page);
  }
}
